import React, { useEffect, useState } from "react";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const InstructorMain = () => {
  const [loading, setLoading] = useState(false);
  const [instructor, setInstructor] = useState([]);

  // modal states
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchInstructor();
  }, []);

  const fetchInstructor = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/instructor`);
      setInstructor(response.data?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // short bio helper
  const shortText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const handleOpenModal = (name, bio) => {
    setTitle(name);
    setDescription(bio);
    setModal(true);
  };

  const handleCloseModal = () => {
    setModal(false);
    setTitle("");
    setDescription("");
  };

  return (
    <div className="instructors___page pt---120 pb---140">
      <div className="container pb---60">
        {!loading && (
          <div className="row">
            {instructor.length === 0 ? (
              <div className="course-message">
                <p className="no-courses">There are no instructor.</p>
              </div>
            ) : (
              instructor.map((data, index) => (
                <div key={index} className="col-lg-3 col-md-6">
                  <div className="instructor__content">
                    <div className="instructor__image">
                      <img
                        crossOrigin="anonymous"
                        className="blog-card-img"
                        src={`https://back.yourfrenchteachers.com/${data?.image}`}
                        alt={data?.name}
                      />

                      <div className="content__hover">
                        {data?.bio && (
                          <p style={{ marginBottom: 20 }}>
                            {shortText(data.bio, 60)}
                            {data.bio.length > 60 && (
                              <span
                                onClick={() =>
                                  handleOpenModal(data.name, data.bio)
                                }
                                style={{
                                  color: "#fff",
                                  cursor: "pointer",
                                  marginLeft: 6,
                                  textDecoration: "underline",
                                  fontSize: 13,
                                }}
                              >
                                View more
                              </span>
                            )}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="bottom-content">
                      <h4>{data?.name}</h4>
                      <p>{data?.role}</p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* Modal */}
        {modal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button
                onClick={handleCloseModal}
                className="close-modal-btn-service"
              >
                ×
              </button>

              <div style={{ padding: 10 }}>
                <div
                  style={{
                    fontSize: 18,
                    paddingBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  {title}
                </div>
                <div>{description}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstructorMain;